<template>
  <div>
    <!--列表-->
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <div style="margin-top: 5px; float:left;font-weight: bold; font-size: 14px">清仓完成进度</div>
        <div style="margin-bottom: 10px; float: right">
          <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
          <el-button type="primary" size="mini" @click="completedBatch">{{completeFlag == 'N' ? '完成批次' : '返回'}}</el-button>
        </div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          highlight-current-row
          :data="tableData.records"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="index < 2 ? 'left': false"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="(item,index) in columnData"
            :key="item.prop"
            :align="item.children ? 'center' : 'left'"
          >
            <template slot-scope="scope">
              <template v-if="item.label.includes('完成率')">
                <el-button type="text" @click="completionRateClick(scope)">{{scope.row[item.prop]}}</el-button>
              </template>
              <template v-else>
                {{ scope.row[item.prop] | cellValFormat }}
              </template>
              
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right; padding-bottom: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <completion-rate-details-dialog :visible.sync="isShowcompletionRate" v-if="isShowcompletionRate" :modifyData="modifyData" />
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import imgShow from "@/views/components/imgShow";
import completionRateDetailsDialog from './completionRateDetails-dialog.vue'
import moment from "moment";
export default {
  name: "newProductSales",
  model: {
    prop: 'searchForm',
    event: 'input'
  },
  components: { imgShow, completionRateDetailsDialog },
  props: ['searchForm', 'storeList'],
  data() {
    return {
      header_H: "38px",
      loading: false,
      exportLoading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      columnData: [],
      loading: false,
      isShowcompletionRate: false,
      completeFlag: 'N',
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        modifyData: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 275;
    },
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  methods: {
    onSearch() {
      this.$refs.table.clearSelection();
      this.tableData.pageNum = 1
      this.init()
    },
    async init(type) {
      this.loading = true
      let time = this.searchForm.date
      let data = {
        ...this.searchForm,
        startTime: time && time.length ? time[0] : '',
        endTime: time && time.length ? time[1] : '',
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        completeFlag: this.completeFlag
      }
      this.searchFormData = data
      this.$q.clearanceManagement.wholeNetworkSearch({data: data}).then(res => {
        if(res.data && res.data.dynamicData) {
          this.tableData = res.data.dynamicData
          this.columnData = res.data.titleList.map(v => {
            return {
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: false,
              span: false,
              fixed: false,
            }
          })
        } else {
          this.tableData.records = []
        }
      }).finally(() => {
        this.loading = false
      });
      
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
        this.$refs.table.clearSelection();
      }
      let searchForm = {
        storeCode: this.storeList[0].storeCode,
        batchNameList: []
      };
      this.$emit('input',searchForm)
      this.tableData.pageNum = 1
      this.$nextTick(_=>{
        this.onSearch()
      })
    },
    completionRateClick(scope) {
      let {row ,column} = scope
      this.isShowcompletionRate = true
      this.modifyData = {
        batchName: row.batchName, 
        monthCode: column.property.replace('completeRatio',''),
        title: column.label.replace('完成率',''),
      }
    },
    completedBatch() {
      this.completeFlag = this.completeFlag == 'N' ? 'Y' : 'N'
      this.$emit('getBatchNameList',this.completeFlag)
      this.init()
    },
     // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$q.clearanceManagement.wholeNetworkExport({data: this.searchFormData,options: { responseType: 'blob' }}).then((res) => {
        let fileName = '清仓管理全网'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.blobDownload( res, `${fileName}.xlsx`);
        loading.close()
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.$emit('getBatchNameList','N')
    this.onSearch()
  },
};
</script>

<style lang="stylus" scoped>

.list-wrapper {
  hieght: 100%
  background-color: #ffffff;
  border:none
  border-radius:40px;
}

.table-wrap {
  padding: 10px;
  border-radius: 6px;
}

>>> .el-link.el-link--primary {
  margin-right: 5px;
}

// >>> .el-table .el-table__fixed {
//     height:auto !important; 
//     bottom:11px; 
// }

// >>> .el-table__fixed-right {
//   height:auto !important; 
//   bottom:11px;
// }


// >>> .el-table__body-wrapper {
//   &::-webkit-scrollbar { // 滚动条高 解决行未对齐
//     height: 11px;
//   }
// }
// >>> .el-table__fixed-body-wrapper .el-table__body {
//   padding-bottom: 11px; // 滚动条高度

// }
</style>
